import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

import estilos from './EditarDescripcion.module.css'

/**
 * LA DESCRIPCIÓN DEL TRABAJO, EDITABLE DESDE LA FICHA (0265).
 *
 * Johan: «esto ¿cómo lo edito?, las observaciones». Antes solo se escribía
 * al crear la orden. Se edita aquí mismo; la bitácora guarda lo que decía
 * antes y quién lo cambió.
 */
export function EditarDescripcion({
  ordenServicioId,
  descripcion,
  puedeEditar,
}: {
  ordenServicioId: string
  descripcion: string | null
  puedeEditar: boolean
}) {
  const cliente = useQueryClient()
  const [editando, setEditando] = useState(false)
  const [texto, setTexto] = useState(descripcion ?? '')

  const guardar = useMutation({
    mutationFn: async () => {
      const { error } = await supabase.rpc('fn_editar_descripcion_orden', {
        p_orden_servicio_id: ordenServicioId,
        p_descripcion: texto,
      })
      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: ['ordenes-servicio'] })
      await cliente.invalidateQueries({ queryKey: ['bitacora'] })
      setEditando(false)
    },
  })

  if (!editando) {
    return (
      <div className={estilos.vista}>
        <span className={estilos.texto}>{descripcion ?? 'Sin descripción.'}</span>
        {puedeEditar && (
          <button
            type="button"
            className={estilos.editar}
            onClick={() => {
              setTexto(descripcion ?? '')
              guardar.reset()
              setEditando(true)
            }}
          >
            Editar
          </button>
        )}
      </div>
    )
  }

  return (
    <div className={estilos.edicion}>
      <textarea
        className={estilos.campo}
        rows={5}
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        autoFocus
        aria-label="Descripción del trabajo"
      />
      {guardar.error && <p className={estilos.error}>{guardar.error.message}</p>}
      <div className={estilos.botones}>
        <button
          type="button"
          className={estilos.principal}
          onClick={() => guardar.mutate()}
          disabled={guardar.isPending || texto.trim().length === 0}
        >
          {guardar.isPending ? 'Guardando…' : 'Guardar'}
        </button>
        <button type="button" className={estilos.secundario} onClick={() => setEditando(false)}>
          Cancelar
        </button>
        <span className={estilos.nota}>Queda en la bitácora lo que decía antes.</span>
      </div>
    </div>
  )
}
